import _ from "lodash";
import { instance } from "../components/AxiosClient";
import GetProfile from "./VariableStore";
import { store } from "../utils/redux/store";


const intervalCount = 3000;
let isData = false;
let isLoad;
let isAbsoluteURLRegex = /^(?:\w+:)\/\//;
let auther = ''


const getQueueId = async (
  apiMethod = "post",
  urlQueue = "",
  apiUrl = "",
  payload = {}
) => {
  const comCode = process.env.REACT_APP_COM_CODE;
const states = store.getState();
let accessToken = states.authenReducer.accessToken;
const langValue = localStorage.getItem('lang');
const customerId = GetProfile("customerId");

  try {
    const body = {
      apiPayload: payload,
      apiHeaders: {
        authorization: `Bearer ${accessToken}`,
        // authorization: auther,
        memcomid: customerId,
        lang: langValue,
      },
      apiMethod: apiMethod,
      apiQuery: {},
      apiUrl: apiUrl,
      memComId: customerId,
    };

    console.log("useQueueApi urlQueue", states.authenReducer);

    const response = await instance.post(urlQueue, body);
    return _.get(response, "data.data.queueId");
  } catch (error) {
    return undefined;
  }
};

const getQueueMessages = async ({
  apiMethod = "post",
  urlQueue = "",
  apiUrl = "",
  payload = {},
}) => {
  const comCode = process.env.REACT_APP_COM_CODE;
  if (apiMethod || urlQueue || apiUrl || payload) {
    const queueId = await getQueueId(apiMethod, urlQueue, apiUrl, payload);

    if (queueId) {
      return new Promise((resolve, reject) => {
        const intervalPoll = setInterval(async () => {
          isLoad = true;
          isData = false;
          try {
            const response = await instance.get(
              `/queue/manager/company/${comCode}/queuemessage/${queueId}`
            );
            console.log("resQueueApi", response);
            if (
              _.get(response, "data.status.code") == 200 &&
              _.get(response, "data.data.waitingQueue") === true
            ) {
              isLoad = false;
              isData = true;
              clearInterval(intervalPoll);
              resolve({ ...response.data, isLoad: isLoad });
            } else {
              isLoad = false;
              isData = false;
              clearInterval(intervalPoll);
              resolve({ ...response.data, isLoad: isLoad });
            }
          } catch (error) {
            isLoad = false;
            isData = false;
            clearInterval(intervalPoll);
            reject(error);
          }
        }, intervalCount);
      });
    }
  }
};

export { getQueueMessages };
